{
  "required": "此欄位為必填。",
  "tooShort": "最少需要 {min} 個字元。",
  "tooLong": "最多只可 {max} 個字元。",
  "invalidEmail": "請輸入有效的電郵地址。",
  "invalidNumber": "請輸入有效的數字。",
  "minAmount": "最少須為 {amount}。"
}
